<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <router-link
        style="text-decoration: none"
        :to="{
          name: ACTIONPLAN_ACTIONS_LIST_ROUTE_NAME,
          params: { actionplanId: actionPlanId },
        }"
      >
        <v-chip
          v-on="on"
          @click="$emit('click')"
          small
          v-bind="$attrs"
          style="cursor: pointer;"
          text-color="opposite"
        >
          N°{{ actionPlanId }}
        </v-chip>
      </router-link>
    </template>
    <span>
      {{ generateMessage('actionplans.item.link') }}
    </span>
  </v-tooltip>
</template>
<script>
import { generateMessage } from '@/utils/i18n';
import { ACTIONPLAN_ACTIONS_LIST_ROUTE_NAME } from '@/router/actions.router';

export default {
  name: 'LinkToActionplan',
  props: {
    actionPlanId: {
      type: [Number, String],
      required: true,
    },
  },
  data: () => ({ ACTIONPLAN_ACTIONS_LIST_ROUTE_NAME }),
  methods: {
    generateMessage,
  },
};
</script>
